import {
  Component,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import {
  CategoryItem,
  CurrencyModel,
  TransactionTypeEnum,
  OutlineItem,
} from '../../models/base.models';
import { ApiService } from '../../services/api.service';
import { Subscription, lastValueFrom } from 'rxjs';

@Component({
  selector: 'formly-field-system-transaction-category',
  encapsulation: ViewEncapsulation.None,
  styles: [
    `
      .child-value-container {
        padding-left: 2.5rem !important;
      }
      .ng-value-label .child-value-container {
        padding-left: 0 !important;
      }
    `,
  ],
  template: `
    <div *ngIf="!loaded; else fieldContainer">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <ng-template #fieldContainer>
      <div class="mb-3">
        <label class="form-label" [for]="field.id">
          {{ field.props.label }}
          <span *ngIf="field.props.required" aria-hidden="true">*</span></label
        >
        <ng-select
          class="ng-select-solid"
          [ngClass]="{
            'is-invalid': formControl.invalid && formControl.touched
          }"
          [labelForId]="field.id"
          [placeholder]="field.props.placeholder"
          [editableSearchTerm]="false"
          [clearSearchOnAdd]="false"
          [clearable]="false"
          type="input"
          [multiple]="false"
          [formControl]="formControl"
        >
          <ng-container *ngFor="let category of categoriesList; let i = index">
            <ng-option [value]="category.id">
              <span class="d-flex align-items-center">
                <div class="symbol symbol-35px me-2">
                  <span class="symbol-label border"
                    ><img
                      *ngIf="!!category.logo"
                      class="w-75 align-self-center"
                      src="{{ category.logo }}"
                    />

                    <span *ngIf="!category.logo">{{ 'logo' }}</span>
                  </span>
                </div>

                <span>
                  {{ category.name }}
                </span>
              </span>
            </ng-option>
            <ng-container *ngIf="category?.children?.length">
              <ng-option
                *ngFor="let childCategory of category.children; let i = index"
                [value]="childCategory.id"
              >
                <span class="child-value-container d-flex align-items-center">
                  <div class="symbol symbol-35px me-2">
                    <span class="symbol-label border"
                      ><img
                        *ngIf="!!childCategory.logo"
                        class="w-75 align-self-center"
                        src="{{ childCategory.logo }}"
                      />

                      <span *ngIf="!childCategory.logo">{{ 'Icon' }}</span>
                    </span>
                  </div>

                  {{ childCategory.name }}
                </span>
              </ng-option>
            </ng-container>
          </ng-container>
        </ng-select>
      </div>
    </ng-template>
  `,
})
export class systemTransactionCategoryFieldType
  extends FieldType<FieldTypeConfig>
  implements OnInit, OnDestroy
{
  loaded: boolean = false;
  categoriesList: CategoryItem[] = [];
  currentSpaceId: number;

  currentTransactionType: TransactionTypeEnum;

  subscriptions: Subscription[] = [];
  constructor(private api: ApiService) {
    super();
  }

  ngOnDestroy(): void {
    this.formControl?.reset();
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  async ngOnInit() {
    this.loaded = false;
    this.currentSpaceId = +this.field.props.attributes['space_id'];
    this.currentTransactionType = this.form.controls['transactionType']
      .value as TransactionTypeEnum;
    await this.handleTransactionTypeChange(this.currentTransactionType);
    await this.watchControlChange();
    this.loaded = true;
  }

  async getSpaceCategories(
    spaceId: number = this.currentSpaceId,
    type: TransactionTypeEnum = this.currentTransactionType
  ) {
    let request$ = this.api.getSpaceCategories(spaceId, type);
    let response = await lastValueFrom(request$);

    return response;
  }

  async watchControlChange() {
    console.log(this.currentTransactionType);
    this.categoriesList = await this.getSpaceCategories(
      this.currentSpaceId,
      this.currentTransactionType
    );

    this.subscriptions.push(
      this.form.controls['transactionType'].valueChanges.subscribe(
        async (value: TransactionTypeEnum) => {
          this.formControl.reset();
          console.log(value);
          this.handleTransactionTypeChange(value);
        }
      )
    );
  }

  async handleTransactionTypeChange(value: TransactionTypeEnum) {
    this.loaded = false;
    this.currentTransactionType = value;
    this.categoriesList = await this.getSpaceCategories(
      this.currentSpaceId,
      value
    );

    switch (this.currentTransactionType) {
      case TransactionTypeEnum.income:
        this.props.label = 'Income Category';
        break;
      case TransactionTypeEnum.expense:
        this.props.label = 'Expense Category';
        break;
      case TransactionTypeEnum.debt:
        this.props.label = 'Debit';
        break;
      case TransactionTypeEnum.credit:
        this.props.label = 'Credit';
        break;
      default:
        break;
    }
    this.loaded = true;
  }
}
